import { create } from 'zustand';

type Theme = 'light' | 'dark' | 'system';

interface ThemeState {
  theme: Theme;
  sidebarCollapsed: boolean;
  setTheme: (theme: Theme) => void;
  toggleSidebar: () => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  theme: (localStorage.getItem('theme') as Theme) || 'system',
  sidebarCollapsed: localStorage.getItem('sidebar_collapsed') === 'true',

  setTheme: (theme) => {
    localStorage.setItem('theme', theme);
    const isDark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    document.documentElement.classList.toggle('dark', isDark);
    set({ theme });
  },

  toggleSidebar: () => {
    set((state) => {
      const collapsed = !state.sidebarCollapsed;
      localStorage.setItem('sidebar_collapsed', String(collapsed));
      return { sidebarCollapsed: collapsed };
    });
  },
}));
